import type { SelectedService } from "@/types/service";

export function haveServicesChanged(
  oldServices: SelectedService[] | null | undefined,
  newServices: SelectedService[]
): boolean {
  const oldIds = new Set(oldServices?.map((s) => s.entity_id) ?? []);
  const newIds = new Set(newServices.map((s) => s.entity_id));

  if (oldIds.size !== newIds.size) return true;

  return newServices.some((s) => !oldIds.has(s.entity_id));
}
